import { render, staticRenderFns } from "./PsnStatutoryNew.vue?vue&type=template&id=cd191f18"
import script from "./PsnStatutoryNew.vue?vue&type=script&lang=js"
export * from "./PsnStatutoryNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports